import { motion } from 'framer-motion';

export const Section = ({ children, className = '', id, dark = false }) => {
  return (
    <section 
      id={id}
      className={`py-10 md:py-14 ${dark ? 'bg-slate-900' : 'bg-background'} ${className}`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        {children}
      </div>
    </section>
  );
};

export const SectionTitle = ({ children, subtitle, className = '' }) => {
  return (
    <motion.div 
      className={`mb-6 md:mb-8 ${className}`}
      initial={{ opacity: 0.6, y: 10 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.1 }}
      transition={{ duration: 0.4 }}
    >
      {subtitle && (
        <span className="text-sm text-gold-400 font-medium uppercase tracking-widest mb-4 block">
          {subtitle}
        </span>
      )}
      <h2 className="text-3xl md:text-5xl font-bold tracking-tight text-white">
        {children}
      </h2>
    </motion.div>
  );
};

export const AnimatedCard = ({ children, className = '', delay = 0 }) => {
  return (
    <motion.div
      className={`bg-card border border-border/50 rounded-xl p-6 md:p-8 hover:border-primary/50 ${className}`}
      initial={{ opacity: 0.5, y: 10 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.1 }}
      transition={{ duration: 0.4, delay }}
      whileHover={{ y: -4, transition: { duration: 0.2 } }}
    >
      {children}
    </motion.div>
  );
};
